import { tv } from 'tailwind-variants';

export const avatarStyle = tv({
  slots: {
    base: 'flex select-none items-center justify-center overflow-hidden shadow-md rounded-md',
    img: 'block'
  },
  variants: {
    size: {
      xs: 'size-6',
      sm: 'size-8',
      md: 'size-10',
      lg: 'size-12',
      xl: 'size-14'
    },
    variant: {
      tile: 'rounded-none',
      rounded: 'rounded-full'
    },
    flat: {
      true: 'shadow-none'
    },
    clickable: {
      true: 'cursor-pointer'
    }
  },
  defaultVariants: {
    size: 'md'
  }
});
